import React, { memo, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import { adminColumnDef, defaultColumnDefs, superUserColumnDefs } from './columnDefinitions';

import { debouncedRebuildReactTooltip } from '../../shared/debouncedRebuildReactTooltip';

import AgGrid from '../../shared/agGrid/agGrid.component';
import { subTagsPropTypes, tagsPropTypes } from './propTypes';

const CategoriesAndTagsGrid = props => {
  const {
    componentToRenderOnSearchBar,
    tagsLoading,
    subTagsLoading,
    tagsList,
    subTagsList,
    shouldDisplayAdminColumn,
    canSeeAdditionalColumns,
  } = props;

  const columnDefs = canSeeAdditionalColumns ? superUserColumnDefs : defaultColumnDefs;

  const modifiedColumnDefs = shouldDisplayAdminColumn ? [adminColumnDef].concat(columnDefs) : columnDefs;

  const subTagsMap = useMemo(() => subTagsList.reduce((accu, subTag) => ({
    ...accu,
    [subTag.value]: subTag.label,
  }), {}), [subTagsList]);

  const tagsListWithTagsNames = useMemo(() => tagsList.map(tag => ({
    ...tag,
    subTag: tag.subTagName,
    subTagName: subTagsMap[tag.subTagName] || tag.subTagName,
  })), [tagsList, subTagsMap]);

  useEffect(() => {
    debouncedRebuildReactTooltip();
  }, [tagsListWithTagsNames]);

  return (
    <div className="ag-grid-full-page-with-secondary-menu-and-tabs">
      <ReactTooltip/>
      <AgGrid
        componentToRenderOnSearchBar={componentToRenderOnSearchBar}
        columnDefs={modifiedColumnDefs}
        rowData={tagsListWithTagsNames}
        withSearchBar
        isGridLoading={tagsLoading | subTagsLoading}
      />
    </div>
  );
};

CategoriesAndTagsGrid.propTypes = {
  tagsList: PropTypes.arrayOf(tagsPropTypes),
  componentToRenderOnSearchBar: PropTypes.node,
  tagsLoading: PropTypes.bool,
  subTagsList: PropTypes.arrayOf(subTagsPropTypes),
  subTagsLoading: PropTypes.bool,
  shouldDisplayAdminColumn: PropTypes.bool.isRequired,
  canSeeAdditionalColumns: PropTypes.bool.isRequired,
};

export default memo(CategoriesAndTagsGrid);
